import { CustomButton } from "@/components/ui/Buttons";
import React, { Dispatch, SetStateAction } from "react";

const PreviousYearModal = ({
  setIsPreviousYearModalOpen,
}: {
  setIsPreviousYearModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <section>
      <div>
        <h3 className="text-2xl font-medium leading-none tracking-[0%] text-center mb-6">
          Previous Year Outcomes
        </h3>
        <CustomButton
          variant="outline"
          border="1px solid #E4E7EC"
          color="#000000"
          borderRadius="8px"
          fontSize="12px"
          padding="6px 27px"
          className="leading-[18px] tracking-[0%] mb-[22px]"
          onClick={() => setIsPreviousYearModalOpen(false)}
        >
          Go Back
        </CustomButton>
        <div className="bg-[#F3F3F3] px-[5px] py-[3.5px] mb-3 rounded-lg w-fit">
          <p className="text-[#777777] text-[15px] leading-none tracking-normal">
            15th August, 2024
          </p>
        </div>
        <h2 className="text-[2xl leading-none tracking-normal font-medium ">
          Independence Day 2024
        </h2>
      </div>

      {/* filters */}
      <div className="flex gap-x-3 my-6">
        <button className="border border-[#E4E7EC] px-[19px] py-[6px] rounded-lg bg-[#F3F3F3] text-[#777777]">
          Past Week
        </button>
      </div>

      {/* <div className="mt-4">
        <ProductCard
          index={video.id}
          key={video.id}
          video={video}
          currentlyPlaying={currentlyPlaying}
          setCurrentlyPlaying={setCurrentlyPlaying}
          setIsDetailsModalOpen={setIsDetailsModalOpen}
          setSelectedVideo={setSelectedVideo}
        />
      </div> */}
    </section>
  );
};

export default PreviousYearModal;
